import axios from 'axios'
import { BUSCAR_RESERVAS_ITINERARIO, BUSCAR_RESERVAS_BPE_ITINERARIO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export function buscarReservasItinerario (idItinerario, idEmpresa, idTrechoOrigem, idTrechoDestino, ordenaPortrecho) {
  let url = `${URL}/reserva/itinerario/${idItinerario}/empresa/${idEmpresa}/reservas`;

  const temParamTrecho = idTrechoOrigem && idTrechoDestino;
  if (temParamTrecho) {
    url += `?idTrechoOrigem=${idTrechoOrigem}&idTrechoDestino=${idTrechoDestino}`;
  }

  if (ordenaPortrecho) {
    if (temParamTrecho) {
      url += `&ordenaPortrecho=${ordenaPortrecho}`;
    } else {
      url += `?ordenaPortrecho=${ordenaPortrecho}`;
    }
  } 
  
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_RESERVAS_ITINERARIO,
        payload: response

      })
  );
}

export function buscarReservasConfiguracaoBpeItinerario (idItinerario, codigoEmpresa, pagina, registrosPorPagina) {
  let url = `${URL}/reserva/itinerario/${idItinerario}/situacao-bpe?empresaId=${codigoEmpresa}`;
  if (registrosPorPagina && pagina) {
    url = `${url}&size=${registrosPorPagina}&from=${pagina}`
  }
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_RESERVAS_BPE_ITINERARIO,
        payload: response

      })
  );
}
